const shopify = {
  footerMessagePaymentVia: 'Pago seguro vía',
  inputCustomerName: 'Nombre y Apellido',
  inputCardExpiryDate: 'Fecha de Expiración',
  errorInsertCardExpiration: 'Por favor, ingresa la fecha de vencimiento de tu tarjeta.',
  errorCardExpired: '¡Ups! La tarjeta que informaste ha expirado.',
  errorInvalidExpirationDate: 'La fecha de vencimiento no es válida.',
  inputCardNumber: 'Número de la tarjeta',
  inputCardSecurityCode: 'Código de Seguridad (CVV)',
  greeting: 'Hola, {customerName}',
  fillCardSecurityCode: 'Completa el código de seguridad de la tarjeta',
  invalidSecurityCode: 'El CVV informado es inválido.',
  invalidCvv: 'El CVV informado es inválido.',
  fillColombianAddress: 'Calle es requerido.',
  invalidColombianAddress: 'El calle es inválido.',
};


module.exports = shopify;
